import {UmpireSuccess} from '../umpire-success';
import {UmpireImage} from '../umpire-image';
import {UmpireTeam} from '../umpire-team';
import {UmpireVenue} from '../umpire-venue';

export interface UmpireClub {
  type: 'club';

  id: string;

  address: string | null;

  chairman: string | null;

  code: string | null;

  email: string | null;

  spokesman: string | null;

  phone: string | null;

  name: string;

  is_main: boolean;

  foundation_year: number | null;

  facebook_url: string | undefined;

  website_url: string | undefined;

  twitter_url: string | undefined;

  youtube_url: string | undefined;

  tiktok_url: string | undefined;

  tickets_url: string | undefined;

  instagram_url: string | undefined;

  main_team_coach: string | null;

  teams: Partial<UmpireTeam>[];

  image: Partial<UmpireImage>;

  additional_asset: Partial<UmpireImage> | undefined;

  background_photo: Partial<UmpireImage>;

  successes: Partial<UmpireSuccess>[];

  venue: Partial<UmpireVenue>;

  relationshipNames: string[];

  slug: string | null;
}
